<template>
  <Pie :chart-data="chartData" :chart-options="chartOptions" :styles="styles"/>
</template>

<script>
import { Pie } from 'vue-chartjs'

export default {
      components: {
            Pie
      },
      props: {
            chartdata: {
                  type: Object,
                  default: null
            },
            options: {
                  type: Object,
                  default: null
            },
            styles: {
                  type: Object,
                  default: () => {}
            }
      },
      data() {
        let extendedOptions = structuredClone(this.options)
        let tempChartData = []
        this.chartdata.datasets[0].data.forEach((v,i) => {
          tempChartData.push({label: this.chartdata.labels[i], value: v})
        })
        tempChartData.sort((a,b) => b.value - a.value)
        let sortedChartData = structuredClone(this.chartdata)
        sortedChartData.labels = []
        sortedChartData.datasets[0].data = []
        tempChartData.forEach((element) => {
          sortedChartData.labels.push(element.label)
          sortedChartData.datasets[0].data.push(element.value)
        })

        extendedOptions.scales = {}
        extendedOptions.plugins.legend.display = true
        extendedOptions.plugins.legend.position = 'left'
        extendedOptions.cutout = '85%'
        extendedOptions.plugins.legend.fullSize = false
        return {
          chartData: sortedChartData,
          chartOptions: extendedOptions
        }
      }
}
</script>